import React, { useState, useContext } from 'react';
import axios from 'axios';
import AuthContext from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import './CreateSeasonPopup.css';

const CreateSeasonPopup = ({ isOpen, onClose, onSuccess }) => {
  const { t } = useTranslation(['sessions-page']);
  const { authTokens } = useContext(AuthContext);
  const [newSeasonData, setNewSeasonData] = useState({ name: '', start_date: '', end_date: '' });

  if (!isOpen) return null;

  const handleInput = (e) => {
    const { name, value } = e.target;
    setNewSeasonData({ ...newSeasonData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND + 'training/season/create',
        newSeasonData,
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authTokens.access}` } }
      );
      if (response.status === 201) {
        setNewSeasonData({ name: '', start_date: '', end_date: '' });
        onSuccess(response.data.id);
      }
    } catch (error) {
      console.error(error);
      toast.error(t('Error creating season'));
    }
  };

  return (
    <div className="create-season-popup">
      <div className="webapp-create-season-popup">
        <div className="webapp-paint-return">
          <button
            type="button"
            onClick={onClose}
          >
            <HiOutlineArrowLeft />
          </button>

          <h1>{t('New Season')}</h1>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="webapp-create-season-popup-content">
            <div className="webapp-create-season-input-group">
              <label className="black-16px-700">
                {t('Season Name')} <span className='webapp-asterisco'>*</span>
              </label>
              <input 
                name="name" 
                placeholder="2023/2024" 
                onChange={handleInput} 
                value={newSeasonData.name} 
                required 
              />
            </div>

            <div className="webapp-create-season-input-group">
              <label className="black-16px-700">
                {t('Start Date')} <span className='webapp-asterisco'>*</span>
              </label>
              <input 
                type="date" 
                name="start_date" 
                onChange={handleInput} 
                value={newSeasonData.start_date} 
                required 
              />
            </div>

            <div className="webapp-create-season-input-group">
              <label className="black-16px-700">
                {t('End Date')} <span className='webapp-asterisco'>*</span>
              </label>
              <input 
                type="date" 
                name="end_date" 
                onChange={handleInput} 
                value={newSeasonData.end_date} 
                required 
              />
            </div>
          </div>

          <div className="create-season-popup-buttons">
            <button 
              type="button" 
              className="create-season-cancel-button" 
              onClick={onClose}
            >
              {t("Cancel")}
            </button>

            <button 
              type="submit" 
              className="create-season-save-button"
            >
              {t("Create Season")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateSeasonPopup;
